import type * as React from 'react';
import { get } from '@Domain/Api';
import aiUsagesFetched, {
	type AiUsagesFetchedAction,
	type AiUsagesFetchedPayload,
} from '@Application/Ai/AiUsages/Actions/aiUsagesFetched';
import aiUsagesFetchFailed, {
	type AiUsagesFetchFailedAction,
} from '@Application/Ai/AiUsages/Actions/aiUsagesFetchFailed';
import type FetchAiUsages from '@Application/Ai/AiUsages/Queries/FetchAiUsages';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AiUsagesFetchedAction | AiUsagesFetchFailedAction;

export default (_query: FetchAiUsages) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AiUsagesFetchedPayload>(`${parameters.api.host}/api/enums/ai-usages`);

			const action = aiUsagesFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiUsagesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
